import { useCallback } from "react";
import {
  CredentialKey,
  CredentialsCallback,
} from "@components/dev-features-dialog/features";
import { LocalStorageUtils } from "@utils/local-storage-utils";

/** Type definition for the return value of the useCredentials hook */
type UseCredentialsProps = Record<CredentialKey, CredentialsCallback>;

/**
 * Custom hook that provides credential actions for the dev features dialog.
 */
export function useCredentials(): UseCredentialsProps {
  /**
   * Persists the Analytics API basic-auth credentials in local storage and reloads the page so
   * the analyticsApiClient picks them up. Temporary solution until JWT auth is implemented.
   * TODO: Remove this logic once JWT auth is implemented: https://faro01.atlassian.net/browse/ST-4680
   */
  const saveAnalyticsCredentials = useCallback(
    (username: string, password: string) => {
      if (username) {
        LocalStorageUtils.setStringItem("analytics-api-username", username);
      } else {
        LocalStorageUtils.removeItem("analytics-api-username");
      }
      if (password) {
        LocalStorageUtils.setStringItem("analytics-api-password", password);
      } else {
        LocalStorageUtils.removeItem("analytics-api-password");
      }
      window.location.reload();
    },
    []
  );

  return {
    saveAnalyticsCredentials,
  };
}
